import type { WizardData } from '@/types';

/**
 * Sets a value in an object by a given path.
 *
 * @example
 * setByPath(obj, "a.b.c", "value")
 * // obj.a.b.c = "value"
 *
 * @param {WizardData} obj the object to modify
 * @param {string} path the path to the value to modify
 * @param {string|number} value the new value
 */
export const setByPath = (
  obj: WizardData,
  path: string,
  value: string | number
) => {
  const keys = path.split('.');
  let cur: any = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i];
    if (!cur[k] || typeof cur[k] !== 'object') cur[k] = {};
    cur = cur[k];
  }

  cur[keys[keys.length - 1]] = value;
};
